import styles from '../../assets/styles/LandingPage/Contact.module.scss';
import { MimaButton, MimaInput, MimaText, MimaToastUtil } from '../../components';
import React, { useState } from 'react';
import Footer from './Footer';
import Header3 from './Header3';
import iconoir_mail from '../../assets/img/iconoir_mail.png';
import icons_location from '../../assets/img/icons_location.png';
import la_facebook from '../../assets/img/la_facebook.png';
import iconoir_twitter from '../../assets/img/iconoir_twitter.png';
import Phone from '../../assets/img/phone.png';
import instagram from '../../assets/img/instagram.png';
import youtub from '../../assets/img/youtube.png';
import threads from '../../assets/img/threads.png';
import linked_in from '../../assets/img/linked_in.png';
import { Formik } from 'formik';
import * as yup from 'yup';
import { SupportController } from '../../controllers';
import constant from '../../utils/constant';
import { phoneRegExp } from '../../utils/utils';

const Contact = () => {
    const [loading, setLoading] = useState(false);

    const onSubmit = async (values, { resetForm }) => {
        const payload = {
            name: values.name,
            email: values.email,
            mobile: values.mobile,
            title: values.title,
            message: values.message,


        }
        setLoading(true);
        const { status, errorMessage } = await SupportController.contactUs(payload);

        if (status === constant.Success) {
            setLoading(false);
            MimaToastUtil.success({
                message: constant.Success,
            });
            setLoading(false);
        } else MimaToastUtil.error({
            message: errorMessage,
        });
        return resetForm();
    }

    const validationSchema = () =>
        yup.object({
            name: yup.string().required("Enter name"),
            email: yup
                .string()
                .trim()
                .email('Enter a valid Email')
                .required('Email Address is required'),
            message: yup.string().required("Enter Message"),
            mobile: yup
                .string()
                .matches(phoneRegExp, 'Phone number is not valid')
                .required('Phone number is required'),
            title: yup.string().required("Enter message title"),
        });

    return (
        <>
            <Header3 />
            <div>
                <MimaText variant="h3" align="center" mt={5} mb={3}>Contact Us</MimaText>
                <section className={styles.contactSection}>
                    <div className={styles.contact}>
                        <div className={styles.contact__mode}>
                            <img
                                src={icons_location}
                                alt='location Icon'
                            />
                            <MimaText variant="bodyBold" mt={1} mb={1}>
                                Address
                            </MimaText>
                            <MimaText variant="body2">
                                745 John Adams CT, Fate Texas 75189
                            </MimaText>
                        </div>
                        <div className={styles.contact__mode}>
                            <img
                                src={Phone}
                                alt='phone Icon'
                            />
                            <MimaText variant="bodyBold" mt={1} mb={1}>
                                Phone
                            </MimaText>
                            <MimaText variant="body2">
                                call on +2348137567029 or +2348050439131
                            </MimaText>
                        </div>
                        <div className={styles.contact__mode}>
                            <img
                                src={iconoir_mail}
                                alt='iconoir_mail'

                            />
                            <MimaText variant="bodyBold" mt={1} mb={1}>
                                Email
                            </MimaText>
                            <MimaText variant="body2">
                                Hello@trymima.com
                            </MimaText>
                        </div>
                        <a className={styles.contact__mode}
                            href="https://twitter.com/MimaBusiness_Hq" target="_blank" rel="noreferrer"
                        >
                            <img
                                src={iconoir_twitter}
                                alt='twitter Icon'
                            />
                            <MimaText variant="bodyBold" mt={1} mb={1}>
                                Twitter
                            </MimaText>
                            <MimaText variant="body2">
                                MimaBusiness_Hq
                            </MimaText>
                        </a>
                        <a className={styles.contact__mode}
                            href="https://web.facebook.com/mimabusinessinc" target="_blank" rel="noreferrer"
                        >
                            <img
                                src={la_facebook}
                                alt='facebook Icon'
                            />
                            <MimaText variant="bodyBold" mt={1} mb={1}>
                                Facebook
                            </MimaText>
                            <MimaText variant="body2">
                                Mimabusinessinc.
                            </MimaText>
                        </a>
                        <a className={styles.contact__mode}
                            href="https://www.instagram.com/mimabusiness_hq/" target="_blank" rel="noreferrer"
                        >
                            <img
                                src={instagram}
                                alt='Instagram Icon'
                            />
                            <MimaText variant="bodyBold" mt={1} mb={1}>
                                Instagram
                            </MimaText>
                            <MimaText variant="body2">
                                Mimabusiness_hq
                            </MimaText>
                        </a>
                        <a className={styles.contact__mode}
                            href="https://www.youtube.com/@MimaBusiness" target="_blank" rel="noreferrer"
                        >
                            <img
                                src={youtub}
                                alt='youtube Icon'
                            />
                            <MimaText variant="bodyBold" mt={1} mb={1}>
                                Youtube
                            </MimaText>
                            <MimaText variant="body2">
                                @MimaBusiness
                            </MimaText>
                        </a>
                        <a className={styles.contact__mode}
                            href="https://www.threads.net/@mimabusiness_hq" target="_blank" rel="noreferrer"
                        >
                            <img
                                src={threads}
                                alt='Threads Icon'
                            />
                            <MimaText variant="bodyBold" mt={1} mb={1}>
                                Threads
                            </MimaText>
                            <MimaText variant="body2">
                                @Mimabusiness_hq
                            </MimaText>
                        </a>
                        <a className={styles.contact__mode}
                            href="https://www.linkedin.com/company/mimabusiness/" target="_blank" rel="noreferrer"
                        >
                            <img
                                src={linked_in}
                                alt='linked in Icon'
                            />
                            <MimaText variant="bodyBold" mt={1} mb={1}>
                                LinkedIn
                            </MimaText>
                            <MimaText variant="body2">
                                Mimabusiness
                            </MimaText>
                        </a>
                    </div>
                    <div className={styles.form}>
                        <MimaText variant="subtitleBold" color="var(--color-primary)" align="center" mb={3}>Drop a line</MimaText>
                        <MimaText variant="smallBold" align="center" mb={4}>Feel free to contact us if you have any further question or concern</MimaText>
                        <Formik
                            initialValues={{
                                name: "",
                                email: "",
                                mobile: "",
                                title: "",
                                message: "",
                            }}
                            validationSchema={validationSchema()}
                            onSubmit={onSubmit}
                        >
                            {({ handleBlur, handleSubmit, handleChange, values, errors, touched }) => {
                                return (
                                    <>
                                        <MimaInput
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange("name")}
                                            error={errors.name}
                                            touched={touched.name}
                                            onBlur={handleBlur("name")}
                                            variant="exchange"
                                            labelTitle="Your Name"
                                            width={38}
                                            mb={4}
                                        />
                                        <MimaInput
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange("email")}
                                            error={errors.email}
                                            touched={touched.email}
                                            onBlur={handleBlur("email")}
                                            variant="exchange"
                                            labelTitle="Your Email"
                                            width={38}
                                            mb={4}
                                        />
                                        <MimaInput
                                            name="mobile"
                                            value={values.mobile}
                                            onChange={handleChange("mobile")}
                                            error={errors.mobile}
                                            touched={touched.mobile}
                                            onBlur={handleBlur("mobile")}
                                            variant="exchange"
                                            labelTitle="Your phone number"
                                            width={38}
                                            mb={4}
                                        />
                                        <MimaInput
                                            name="title"
                                            value={values.title}
                                            onChange={handleChange("title")}
                                            error={errors.title}
                                            touched={touched.title}
                                            onBlur={handleBlur("title")}
                                            variant="exchange"
                                            labelTitle="Your message title"
                                            width={38}
                                            mb={4}

                                        />
                                        <MimaInput
                                            name="message"
                                            value={values.message}
                                            onChange={handleChange("message")}
                                            error={errors.message}
                                            touched={touched.message}
                                            onBlur={handleBlur("message")}
                                            variant="exchange"
                                            labelTitle="Your Message"
                                            width={38}
                                            mb={4}

                                        />

                                        <MimaButton
                                            loading={loading}
                                            title="Send message"
                                            height={5}
                                            onClick={handleSubmit}
                                            width={30}
                                            mb={4}
                                        />
                                    </>
                                )
                            }}

                        </Formik>

                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default Contact;
